import { Comedian, SpecialRow } from "@punchup/data/legacy";

import { AttendanceData } from "@punchup/data/legacy";
import Image from "next/image";
import { comedianGradientBg } from "../../resources";
import { formatCurrency } from "@punchup/utils/currency";
import { formatRuntime } from "@punchup/utils/formatRuntime";

export default function ComedianSigninHeader({
  comedian,
  aboutImg,
  specialImg,
  special,
  attendanceData,
}: {
  comedian: Comedian;
  aboutImg: string | null;
  specialImg?: string | null;
  special?: SpecialRow;
  attendanceData?: AttendanceData;
}) {
  const { display_name, display_name_short } = comedian;

  return (
    <div className="flex flex-col items-center gap-4 md:pb-4">
      {special && specialImg ? (
        <div className="flex flex-row justify-center w-full">
          {/* display the special image */}
          <Image
            className="object-cover w-full h-auto rounded-md max-w-[50%] md:max-w-xs aspect-square"
            width={200}
            height={200}
            src={specialImg}
            alt={`${display_name} special`}
          />
        </div>
      ) : (
        <div className="flex flex-row items-center justify-center w-full gap-6 px-4 pt-4 md:px-6">
          {/* display the comedian's signature image and profile picture */}
          {aboutImg && (
            <Image
              className="rounded-full h-[60px] w-[60px] md:h-[75px] md:w-[75px] object-cover aspect-square bg-cover bg-center"
              width={75}
              height={75}
              src={aboutImg}
              alt={`${display_name} profile picture`}
              style={{
                backgroundImage: `url(${comedianGradientBg.src})`,
              }}
            />
          )}
        </div>
      )}
      <div className="flex flex-col items-center justify-center gap-1.5">
        {special ? (
          special.requires_purchase ? (
            <>
              <h1 className="font-sans text-[17px] font-bold leading-tight text-center normal-case md:text-xl">
                Join {display_name_short}&apos;s{" "}
                <span className="whitespace-nowrap">guest list</span>
              </h1>
              <p className="text-secondary-blue text-[13px] md:text-[16px] text-center leading-tight">
                Join to purchase the full video for{" "}
                {formatCurrency(special.price)} and get exclusive updates – no
                spam, just the good stuff!
              </p>
            </>
          ) : (
            <>
              <h1 className="font-sans text-[17px] font-bold leading-tight text-center normal-case md:text-xl">
                Join {display_name_short}&apos;s{" "}
                <span className="whitespace-nowrap">guest list</span>
              </h1>
              <p className="text-secondary-blue text-[13px] md:text-[16px] text-center leading-tight">
                Join to watch the{" "}
                {special.livestream
                  ? "live stream"
                  : `full ${formatRuntime(special.runtime)} video`}{" "}
                and get exclusive updates – no spam, just the good stuff!
              </p>
            </>
          )
        ) : (
          <>
            <h1 className="font-sans text-[17px] font-bold leading-tight text-center normal-case md:text-xl">
              {attendanceData
                ? `Thanks for coming to see ${display_name_short}!`
                : `Join ${display_name_short}'s guest list`}
            </h1>
            <p className="text-secondary-blue text-[13px] md:text-[16px] text-center leading-tight">
              {attendanceData
                ? `Join his Guest List to stay connected with ${display_name_short} and get special access to future shows and events.`
                : `Join for exclusive updates, first dibs on specials, and local tour dates – no spam, just the good stuff!`}
            </p>
          </>
        )}
      </div>
    </div>
  );
}
